import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadStylesService {

  constructor() {
  }

  loadStyle(styleName: string, callback: any = null) {
    const head = document.getElementsByTagName('head')[0];
    let styleLink = document.getElementById(styleName) as HTMLLinkElement;
    if (!styleLink) {
      const elem = document.createElement('link');
      elem.id = styleName + "style";
      elem.rel = 'stylesheet';
      elem.href = `${styleName}.css`;
      if (callback) {
        elem.addEventListener('load', callback);
      }
      head.prepend(elem);
      return elem;
    }
    return null;
  }
}
